import { render, staticRenderFns } from "./MissionRankingSelfNotRankedParts.vue?vue&type=template&id=fae71d62&scoped=true"
import script from "./MissionRankingSelfNotRankedParts.vue?vue&type=script&lang=ts"
export * from "./MissionRankingSelfNotRankedParts.vue?vue&type=script&lang=ts"
import style0 from "./MissionRankingSelfNotRankedParts.vue?vue&type=style&index=0&id=fae71d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae71d62",
  null
  
)

export default component.exports